module.exports = __webpack_public_path__ + "static/media/instagram-4x.58d84fa0.png";